import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=6bb86fcf&scoped=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"
import style0 from "./Login.vue?vue&type=style&index=0&id=6bb86fcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb86fcf",
  null
  
)

export default component.exports